import { render, staticRenderFns } from "./projects_by_type.vue?vue&type=template&id=6f3e3e06&"
import script from "./projects_by_type.vue?vue&type=script&lang=js&"
export * from "./projects_by_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3e3e06')) {
      api.createRecord('6f3e3e06', component.options)
    } else {
      api.reload('6f3e3e06', component.options)
    }
    module.hot.accept("./projects_by_type.vue?vue&type=template&id=6f3e3e06&", function () {
      api.rerender('6f3e3e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/projects_by_type.vue"
export default component.exports